'use client';

import { useQuery } from '@tanstack/react-query';
import { fetchRankingList } from '@fe-news/actions/my-track';
import { useMyTrackDate } from '@fe-news/context/my-track-date-provider';

// type
import { RankingProductType } from '@fe-news/constants/my-track/type';

const MAX_RANKING_LIST_COUNT = 10;
const ASIDE_MAX_RANKING_LIST_COUNT = 3;

type UseRankingListType = {
  type: RankingProductType;
  isAside?: boolean;
};

const useRankingList = ({ type, isAside = false }: UseRankingListType) => {
  const { timeStamp } = useMyTrackDate();

  const {
    data: rankingList,
    isError: fetchError,
    isLoading
  } = useQuery({
    queryKey: ['rankingList', `time: ${Math.floor(timeStamp / 1000)}`, `type: ${type}`],
    queryFn: () => fetchRankingList({ type: type, time: timeStamp })
  });

  const rankingListData = rankingList?.data?.items ?? [];

  const isError = fetchError || rankingList?.isError;

  const errorMessage = rankingList?.message;

  return {
    data: rankingListData.slice(0, isAside ? ASIDE_MAX_RANKING_LIST_COUNT : MAX_RANKING_LIST_COUNT),
    isError,
    errorMessage,
    isLoading
  };
};

export default useRankingList;
